export const paths = ['/documents/rfis'];
